(() => {
  'use strict';
  // Multiple independently rendered sections can request this shared asset.
  if (window.SouqizaMerchandising) {
    window.SouqizaMerchandising.init(document);
    return;
  }
  const instances = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(section) {
    if (instances.has(section)) return;
    const controller = new AbortController();
    const on = (target, event, callback) => target.addEventListener(event, callback, { signal: controller.signal });
    const controls = section.querySelector('[data-merch-controls]');
    const previous = section.querySelector('[data-merch-prev]');
    const next = section.querySelector('[data-merch-next]');
    let cleanup = () => {};
    let selectBlock = () => {};

    if (section.dataset.merchKind === 'spotlight') {
      const slides = [...section.querySelectorAll('[data-merch-slide]')];
      const status = section.querySelector('[data-merch-status]');
      const play = section.querySelector('[data-merch-play]');
      const editor = section.dataset.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
      let index = 0;
      let timer;
      let paused = section.dataset.autoplay !== 'true' || motion.matches || editor;
      let hovering = section.matches(':hover');
      function stop() { window.clearTimeout(timer); }
      function schedule() {
        stop();
        if (controller.signal.aborted) return;
        if (!paused && !editor && !motion.matches && !hovering && !section.contains(document.activeElement) && !document.hidden && slides.length > 1) {
          timer = window.setTimeout(() => show(index + 1, false), Number(section.dataset.interval) || 7000);
        }
      }
      function show(target, announce = true) {
        if (!slides.length) return;
        index = (target + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${i + 1} of ${slides.length}`);
        });
        if (status) {
          status.setAttribute('aria-live', announce ? 'polite' : 'off');
          status.textContent = `${index + 1} / ${slides.length}`;
        }
        schedule();
      }
      function updatePlay() {
        if (!play) return;
        play.hidden = editor || motion.matches || slides.length < 2;
        play.textContent = paused ? 'Start rotation' : 'Pause rotation';
      }
      if (slides.length > 1 && controls) {
        controls.hidden = false;
        section.setAttribute('aria-roledescription', 'carousel');
        on(previous, 'click', () => { paused = true; updatePlay(); show(index - 1); });
        on(next, 'click', () => { paused = true; updatePlay(); show(index + 1); });
        on(play, 'click', () => { paused = !paused; updatePlay(); schedule(); });
        on(section, 'mouseenter', () => { hovering = true; stop(); });
        on(section, 'mouseleave', () => { hovering = false; schedule(); });
        on(section, 'focusin', stop);
        on(section, 'focusout', () => { queueMicrotask(schedule); });
        on(document, 'visibilitychange', schedule);
        on(motion, 'change', () => { if (motion.matches) paused = true; updatePlay(); schedule(); });
      }
      selectBlock = (id) => {
        const target = slides.findIndex(slide => slide.dataset.blockId === id);
        if (target >= 0) { paused = true; updatePlay(); show(target); }
      };
      updatePlay();
      show(0, false);
      cleanup = stop;
    } else {
      const rail = section.querySelector('[data-merch-rail]');
      if (rail && controls) {
        const update = () => {
          const rtl = getComputedStyle(rail).direction === 'rtl';
          const position = rtl ? -rail.scrollLeft : rail.scrollLeft;
          previous.disabled = position <= 2;
          next.disabled = position >= rail.scrollWidth - rail.clientWidth - 2;
          controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
        };
        const move = (direction) => {
          const rtl = getComputedStyle(rail).direction === 'rtl';
          rail.scrollBy({ left: direction * (rtl ? -1 : 1) * rail.clientWidth * 0.85, behavior: motion.matches ? 'instant' : 'smooth' });
        };
        on(previous, 'click', () => move(-1));
        on(next, 'click', () => move(1));
        on(rail, 'scroll', update);
        on(window, 'resize', update);
        const observer = new ResizeObserver(update);
        observer.observe(rail);
        update();
        selectBlock = (id) => {
          const block = [...rail.children].find(child => {
            const attributes = child.getAttribute('data-shopify-editor-block');
            if (!attributes) return false;
            try { return JSON.parse(attributes).id === id; } catch { return false; }
          });
          if (block) block.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        };
        cleanup = () => observer.disconnect();
      }
    }
    instances.set(section, {
      selectBlock,
      destroy() {
        controller.abort();
        cleanup();
        section.querySelectorAll('video').forEach(video => video.pause());
        instances.delete(section);
      }
    });
  }
  function init(root) {
    if (root.matches && root.matches('[data-merch-section]')) initialize(root);
    root.querySelectorAll('[data-merch-section]').forEach(initialize);
  }
  window.SouqizaMerchandising = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, section) => {
      if (event.target === section || event.target.contains(section)) instance.destroy();
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest('[data-merch-section]');
    const instance = instances.get(section);
    if (instance) instance.selectBlock(event.detail.blockId);
  });
})();
